import { QuestionGroup, ScenarioStep, Steps } from '../state/interfaces'
import { emailAddress, thanks } from './common-steps'

export const emailAddressClientInfoInternet: ScenarioStep = {
  ...emailAddress,
  question: 'client-info-internet_question' as any,
  group: QuestionGroup.DEFAULT,
  next: Steps.THANKS,
}

export const thanksClientInfoInternet: ScenarioStep = {
  ...thanks,
  question: 'client-info-internet-thanks_question' as any,
  tip: 'thanks-government_tip',
  answers: [
    {
      id: 'close',
      text: 'common_continue',
    },
  ],
}
